/* LILINMOMO section-storybook-newsletter.js — Chat 04 §9.7
   Progressive enhancement only: intercepts the native {% form 'customer' %} submit
   and shows the success message inline (no full reload). If fetch is unavailable or
   the request fails, the native form submit proceeds unchanged.
   mount/unmount honor Dawn's shopify:section:load / :unload re-render contract. */

(function () {

  function mount(root) {
    var wrap = root.querySelector('.newsletter-inner');
    var form = root.querySelector('.newsletter-form');
    if (!wrap || !form || !window.fetch) return;

    function showSuccess() {
      var msg = wrap.getAttribute('data-success') || 'Joined';
      var p = document.createElement('p');
      p.className = 'newsletter-success';
      p.setAttribute('role', 'status');
      p.textContent = msg;
      form.replaceWith(p);
    }

    function onSubmit(e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
        .then(function () { showSuccess(); })
        .catch(function () { form.submit(); }); // network failure → real native submit
    }

    form._lmSubmit = onSubmit;
    form.addEventListener('submit', onSubmit);
  }

  function unmount(root) {
    var form = root.querySelector('.newsletter-form');
    if (form && form._lmSubmit) {
      form.removeEventListener('submit', form._lmSubmit);
      form._lmSubmit = null;
    }
  }

  // First paint
  document.querySelectorAll('.section-newsletter').forEach(mount);

  // Theme editor re-render contract
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-newsletter')) mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.classList.contains('section-newsletter')) unmount(e.target);
  });
})();
